import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-1 flex-wrap mb-2 w-full justify-center" }
const _hoisted_2 = ["onClick", "onMouseover"]
const _hoisted_3 = { class: "h-12 w-12 rounded-2xl flex overflow-hidden relative" }
const _hoisted_4 = ["src", "srcset"]
const _hoisted_5 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }
const _hoisted_6 = { class: "flex gap-x-1 flex-wrap mb-2 w-full justify-center" }
const _hoisted_7 = ["onClick", "onMouseover"]
const _hoisted_8 = { class: "h-12 w-12 rounded-2xl flex overflow-hidden relative" }
const _hoisted_9 = ["src", "srcset"]
const _hoisted_10 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }

import ItemV3ParameterBox from "@/components/itemV3/parameter/itemV3ParameterBox.vue";
import ItemV3MostSelected from "@/components/itemV3/parameter/itemV3MostSelected.vue";
import {computed, inject, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import {getCurrentText} from "@/assets/ts/itemText";

const imageWidthPercent: number = 30
const boxIdx = "ratio"

const variantIdx = "discs.ratio"


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3DiscsRatio',
  props: ["item"],
  emits: ["patch"],
  setup(__props, { emit: __emit }) {


const {t} = useI18n();

const emit = __emit;
const props = __props;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

const loading = ref(true)

/**
 * Parameter box header images
 */

const mainMetal = computed(() => store.getters["session/getMainMetal"])
const getHeaderImage = (size: string = "600x300", withBg = false) => {
  if (withBg) {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${mainMetal.value}_${boxIdx}.webp`
  } else {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${boxIdx}.webp`
  }
}

/**
 * session
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

const currentDiscsRatioText = computed(() => {
  return getCurrentText(configureAll.value ? -1 : itemIdx.value, variantIdx)
})

const open = ref(false)

const variants = computed(() => open.value ? parametersVariations.getVariants() : [])

/**
 * color variants
 */

const activeIdx = ref(0)

const variantsList = computed(() => {
  if (!variants.value.length || variants.value.length < activeIdx.value) return []
  return variants.value[activeIdx.value].values
})

const active = computed(() => {
  if (!variants.value.length || variants.value.length < activeIdx.value) return []
  return variants.value[activeIdx.value]
})

const matchedIdx = computed(() => {
  if (!variants.value.length || variants.value.length < activeIdx.value) return 0
  return variants.value[activeIdx.value].values.findIndex((v: any) => v.match)
})

/**
 * image
 */

const hoverIdx = ref(-1)

const setHoverIdx = () => {
  if (matchedIdx.value !== -1 && variantsList.value.length >= matchedIdx.value) {
    hoverIdx.value = matchedIdx.value
  }
}

watch(active, () => {
  setHoverIdx()
})

watch(props.item, () => {
  setHoverIdx()
})

const imageUrl = computed(() => parametersVariations.imageUrl(variantsList.value, hoverIdx.value))

const getMainImageUrl = (image: string) => {
  if (!image) return ''
  return image
}

const checkImageLoaded = (url: string) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(true);
    img.src = url;
  });
};

const checkAllLoaded = async () => {
  const profiles = variants.value;

  if (!profiles.length) return;
  const allListsCreated = profiles.every((profile: any) => profile.values && profile.values.length > 0);
  if (!allListsCreated) return;

  loading.value = false;
};

watch(variants, () => {
  checkAllLoaded();
}, {immediate: true, deep: true});

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};

/**
 * tip texts
 */

const getTipTitle = computed(() => {
  if (active.value && active.value.values[hoverIdx.value]) {
    const key = hoverIdx.value == -1 ? 'free' : active.value.values[hoverIdx.value].idx || 'free'
    return t('components.parameters.tips.discsRatio.' + key + '.title')
  } else {
    return t('components.parameters.tips.discsRatio.free.title')
  }
})

const getTipText = computed(() => {
  if (active.value && active.value.values[hoverIdx.value]) {
    const key = hoverIdx.value == -1 ? 'free' : active.value.values[hoverIdx.value].idx || 'free'
    return t('components.parameters.tips.discsRatio.' + key + '.text')
  } else {
    return t('components.parameters.tips.discsRatio.free.text')
  }
})

const getTipImageUrl = computed(() => {
  if (active.value && active.value.values[hoverIdx.value]) {
    const key = active.value.values[hoverIdx.value].idx.replaceAll(":", "-")
    return 'https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/tips/ratio/300/emotion-' + key + '.webp'

  } else {
    return 'https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/tips/ratio/300/scheiben-free-emotional.webp'
  }
})

onMounted(
    () => {
      setHoverIdx()
    }
)

/*
 * focus values
 */

const focusValueIdx = [
  // idx must be a string with one decimal digit
  "1",
  "1:1",
  "2:1",
  "3:1",
  "1:1:1"
]

const getFocusValueIdx = computed(
    () => {
      if (matchedIdx.value && matchedIdx.value != -1) {
        if (!focusValueIdx.includes(variants.value[activeIdx.value].values[matchedIdx.value].idx)) {
          return [
            variants.value[activeIdx.value].values[matchedIdx.value].idx,
            ...focusValueIdx.slice(0, -1)
          ]
        }
      }

      return focusValueIdx
    }
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ItemV3ParameterBox, {
    open: open.value,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
    "image-width-percent": imageWidthPercent,
    image: imageUrl.value,
    "header-image": getHeaderImage(),
    "header-image-srcset": getHeaderImage() + ' 300w, ' + getHeaderImage('1200x600') +' 600w',
    title: "Aufteilungen",
    subtitle: currentDiscsRatioText.value || 'Wählen Sie die Scheibenaufteilung für Ihre Trauringe',
    loading: loading.value,
    "tip-title": getTipTitle.value,
    "tip-text": getTipText.value,
    "tip-image": getTipImageUrl.value
  }, {
    main: _withCtx(() => [
      _createVNode(ItemV3MostSelected),
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsList.value, (variantData, variantIdx) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (getFocusValueIdx.value.includes(variantData.idx))
              ? (_openBlock(), _createElementBlock("li", {
                  key: variantIdx,
                  class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData)),
                  onMouseover: ($event: any) => (hoverIdx.value = variantIdx as number),
                  onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverIdx.value = matchedIdx.value))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/ratio/100x300/scheiben-${variantData.idx.replaceAll(':', '-')}-hochkant.webp`,
                      srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/ratio/200x600/scheiben-${variantData.idx.replaceAll(':', '-')}-hochkant.webp`,
                      class: "flex h-36 w-auto -top-8 object-top object-cover relative"
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(variantData.title), 1)
                ], 42, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    more: _withCtx(() => [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsList.value, (variantData, variantIdx) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!getFocusValueIdx.value.includes(variantData.idx))
              ? (_openBlock(), _createElementBlock("li", {
                  key: variantIdx,
                  class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData)),
                  onMouseover: ($event: any) => (hoverIdx.value = variantIdx as number),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverIdx.value = matchedIdx.value))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/ratio/100x300/scheiben-${variantData.idx.replaceAll(':', '-')}-hochkant.webp`,
                      srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/ratio/200x600/scheiben-${variantData.idx.replaceAll(':', '-')}-hochkant.webp`,
                      class: "flex h-36 w-auto -top-8 object-top object-cover relative"
                    }, null, 8, _hoisted_9)
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(variantData.title), 1)
                ], 42, _hoisted_7))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    _: 1
  }, 8, ["open", "image", "header-image", "header-image-srcset", "subtitle", "loading", "tip-title", "tip-text", "tip-image"]))
}
}

})